import { FC } from "react";
import { Button, ButtonProps, cn } from "@nextui-org/react";

interface IProps extends ButtonProps {}

export const StyledButton: FC<IProps> = (props) => {
  const { className, ...rest } = props;

  return (
    <Button className={cn("h-10 min-w-10 shrink-0", className)} {...rest}>
      {props.children}
    </Button>
  );
};
